import gql from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const GET_CHART_QUERY = gql`
  query GetChart($chartId: StrictString!) @skipAudit @engComponent(name: CHARTING) {
    chart(id: $chartId) {
      ... on ChartNode {
        id
        name
        library
        libraryVersion
        libraryConfig
        rasterDownloadUrl
        rasterExternalFileId
      }
      ...InaccessibleInfoGraphQL
    }
  }

  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
